/* eslint-disable no-restricted-globals */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import disableInFastboot from '@triptyk/ember-utils/decorators/disable-in-fastboot';
import type ActionModel from 'frontend/models/action';

export interface FormationPartsActionsPlaceComponentArgs {
  actionModel: ActionModel;
}

export default class FormationPartsActionsPlaceComponent extends Component<FormationPartsActionsPlaceComponentArgs> {
  get placeUrl() {
    const googleUrl = 'https://www.google.com/maps/place/';
    const address = `${this.args.actionModel.address.streetAndNumber} ${this.args.actionModel.address.zip} ${this.args.actionModel.address.town}`;
    return `${googleUrl}${encodeURIComponent(address)}`;
  }

  @action
  @disableInFastboot
  openMapUrl() {
    window.open(this.placeUrl);
  }
}
